<template>
  <aside class="control-sidebar control-sidebar-light" :class="{'control-sidebar-open': mostrar}">
    <form @submit.prevent="guardar" v-if="selectedItem">
      <div class="row">
        <div class="form-group col-sm-6">
            <label for="codigo_proyecto">Codigo Proyecto</label>
            <input type="text" class="form-control" name="codigo_proyecto" :disabled="true" v-model="selectedItem.codigo_proyecto">
        </div>
        <div class="form-group col-sm-6">
            <label for="nombre_proyecto">Nombre Proyecto</label>
            <input type="text" name="nombre_proyecto" v-model="selectedItem.nombre_proyecto" class="form-control" :disabled="true" v-validate="'required'" data-vv-validate-on="none"/>
            <span class="text-danger" v-show="errors.first('nombre_proyecto')">{{ errors.first('nombre_proyecto') }}</span>        
        </div>
        <div class="form-group col-sm-6">
            <label for="cliente_empresa">Cliente</label>
            <input type="text" name="cliente_empresa" v-model="selectedItem.cliente_empresa" class="form-control" :disabled="true" v-validate="'required'" data-vv-validate-on="none"/>
            <span class="text-danger" v-show="errors.first('cliente_empresa')">{{ errors.first('cliente_empresa') }}</span>        
        </div>
        <div class="form-group col-sm-6">
            <label for="usuario">Usuario</label>
            <input type="text" name="usuario" v-model="selectedItem.usuario" class="form-control" :disabled="true" v-validate="'required'" data-vv-validate-on="none"/>
            <span class="text-danger" v-show="errors.first('usuario')">{{ errors.first('usuario') }}</span>        
        </div> 
        <div class="form-group col-sm-6">
            <label for="fecha">Fecha</label>
            <datepicker name="fecha" v-model="selectedItem.fecha" :input-class="'form-control'" :language="es" :format="'dd MMMM'" :disabled="!editar"></datepicker>
            <span class="text-danger" v-show="errors.first('fecha')">{{ errors.first('fecha') }}</span>     
        </div>
        <div class="form-group col-sm-6">
            <label for="tipo_reporte">Tipo de reporte</label>
            <select class="form-control" v-model="selectedItem.tipo_reporte" name="tipo_reporte" v-validate="'required'" data-vv-validate-on="none" :disabled="!editar || selectedItem.id">
              <option :value="null">Todos los tipos</option>
              <option :value="'media'">Media</option>
              <option :value="'reporte'">Reporte</option>
            </select>
            <span class="text-danger" v-show="errors.first('tipo_reporte')">{{ errors.first('tipo_reporte') }}</span>        
        </div> 
      </div>

      <div class="row">
        <div class="form-group col-sm-12">
          <label for="media">Media</label>
        </div>
        <div class="clearfix"></div>
        <vue-gallery-slideshow v-if="selectedItem.tipo_reporte === 'media'" :images="imageGallery" :index="indexGallery" @close="indexGallery = null"></vue-gallery-slideshow>
        <template v-if="selectedItem.media.length > 0" v-for="(file, index) in selectedItem.media">
          <div v-if="selectedItem.tipo_reporte === 'media'" class="col-xs-6 col-sm-3">
            <div class="thumbnail">
              <a :key="index" @click="indexGallery = index">
                <img :src="file.url" :alt="file.name">
              </a>
              <div class="caption">
                <a v-if="editar" href="javascript:void(0)" class="tbtn btn-xs text-danger lnk-borrar-media" @click="borrarMedia(file, index)">
                  <i class="fa fa-trash"></i> Borrar
                </a>
              </div>
            </div>
          </div> 
          <div v-else class="col-xs-6 col-sm-3">
            <a class="info-box" :href="file.url" target="_blank">
              <span class="info-box-icon bg-green"><i class="fa fa-file"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">
                  <a v-if="editar" href="javascript:void(0)" class="text-danger lnk-borrar-media" @click="borrarMedia(file, index)">
                    <i class="fa fa-trash"></i>
                  </a>
                  {{ file.name }}
                </span>
                <span class="info-box-number">
                  {{ file.size }} KB
                </span>

              </div>
            </a>
          </div>                   
        </template>
        <div class="col-xs-6 col-sm-3" v-if="$store.state.online">
          <div class="box box-solid">
            <div class="box-body text-center"  :class="{'drop-active': $refs.upload && $refs.upload.dropActive}">
                <h4>Arrastra los archivos aquí<br/>o</h4>
                <div class="progress progress-sm active" v-for="(file, index) in files" :key="file.id">
                  <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" :aria-valuenow="file.progress" aria-valuemin="0" aria-valuemax="100" :style="{ width: file.progress+'%' }">
                    <span class="sr-only">{{ file.progress }}% Complete</span>
                  </div>
                </div>                                      
                <file-upload

                  class="btn btn-xs"
                  name="files"
                  ref="upload"
                  v-model="files"
                  :drop="true"
                  :headers="postImageHeader"
                  post-action="https://data.sima-api.com/upload"
                  @input-file="inputFile"
                  @input-filter="inputFilter"
                >
                <i class="fa fa-plus"></i> Selecciona archivos
                </file-upload>
            </div>
          </div>
        </div>          
        <div v-if="selectedItem.media.length == 0" class="form-group col-sm-12">
          <p><i class="icon fa fa-warning"></i> No hay archivos cargados</p>
        </div>        
      </div>

      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn bg-red" v-if="editar">
            Guardar
            <div v-if="guardando" class="loading"></div>
          </button>
          <button type="button" class="btn btn-default" @click="cerrar()">
            <i class="fa fa-close"></i> Cerrar
          </button>          
        </div>
      </div>
    </form>
    <div class="visible-xs visible-sm" style="height:20%;">&nbsp;</div>
  </aside>  
</template>
<script>
import { mapGetters } from 'vuex'
import api from '../../../api'
import localStorage from '../../../core/local-storage'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import db from '../../../core/pouchdb'
import _ from 'lodash'
import FileUpload from 'vue-upload-component'
import VueGallerySlideshow from 'vue-gallery-slideshow'
// import moment from 'moment'
export default {
  name: 'AMReporteMedia',
  components: {
    Datepicker,
    FileUpload,
    VueGallerySlideshow
  },
  props: {
    item: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    mostrar: {
      type: Boolean,
      default () {
        return false
      }
    },
    editar: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      es: es,
      selectedItem: this.item || null,
      errores: '',
      guardando: false,
      proyecto: null,
      files: [],
      postImageHeader: {authorization: 'Bearer ' + localStorage.getToken()},
      indexGallery: null
    }
  },
  computed: {
    ...mapGetters([
      'getProyectoPorCodigo'
    ]),
    imageGallery: function () {
      let images = []
      if (this.selectedItem && this.selectedItem.tipo_reporte === 'media') {
        for (let i = 0; i < this.selectedItem.media.length; i++) {
          images.push(this.selectedItem.media[i].url)
        }
      }
      return images
    }
  },
  methods: {
    guardar () {
      let vm = this
      this.$validator.validate().then(result => {
        if (result) {
          let item = _.cloneDeep(this.selectedItem)
          vm.errores = ''
          vm.guardando = true
          if (vm.$store.state.online) {
            api.saveReportes(item).then(data => {
              vm.guardando = false
              vm.cerrar(data)
            }, error => {
              vm.guardando = false
              vm.errores = error.message
            })
          } else {
            db.save(item, 'reporte_media', item.id ? 'edit' : 'create').then(function (response) {
              if (typeof item.fecha !== 'string') {
                item.fecha = item.fecha.toISOString()
              }
              item._rev = response.rev
              vm.guardando = false
              vm.cerrar(item)
            }).catch(function (error) {
              vm.guardando = false
              vm.errores = error.message
              console.debug(error)
            })
          }
        }
      })
    },
    cerrar (item) {
      this.errores = ''
      this.$emit('am-rm:cerrar', (item || null))
    },
    mostrarInfoProyecto () {
      if (this.proyecto) {
        this.selectedItem.codigo_proyecto = this.proyecto.codigo_proyecto
        this.selectedItem.cliente_empresa = this.proyecto.cliente_empresa
        this.selectedItem.nombre_proyecto = this.proyecto.nombre_proyecto
      } else {
        this.selectedItem.codigo_proyecto = null
        this.selectedItem.cliente_empresa = null
        this.selectedItem.nombre_proyecto = null
      }
    },
    borrarMedia (item, index) {
      if (confirm('Desea eliminar el archivo?')) {
        this.selectedItem.media.splice(index, 1)
      }
    },
    inputFile: function (newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
      if (newFile && oldFile) {
        if (newFile.success) {
          this.selectedItem.media.push(newFile.response[0])
          this.$refs.upload.clear()
        }
      }
      /* if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      } */
    },
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (this.selectedItem.tipo_reporte === 'media') {
          if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
            return prevent()
          }
        } else {
          if (!/\.(pdf)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      }

      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    }
  },
  watch: {
    item: function (a, b) {
      if (a) {
        this.selectedItem = a
        this.proyecto = this.getProyectoPorCodigo(a.codigo_proyecto)
        this.mostrarInfoProyecto()
      }
    }
  }
}
</script>
<style scoped>
.control-sidebar.control-sidebar-open{

  min-width: 100%;  
}
.progress-description, .info-box-text {
  white-space: normal;
  overflow: initial;
  color: #000;
  font-size: 13px;
}
.info-box-number {
  font-weight: normal;
  font-size: 13px;
  color: #999;  
}
.lnk-borrar-media {
  display: block;
  text-align: center;
}
.drop-active {
  border: 2px dashed #000;
}
.btn-upload, .btn-upload label {
  cursor: pointer;
  display: block;
}

</style>


// WEBPACK FOOTER //
// src/components/views/reportes-media/AMReporteMedia.vue